import { HeartBank } from "../../../managers/HeartBank.ts";
import { Hero } from "../../../managers/Hero.ts";
import template from "./hb-features.mjs";
import { render } from "lit-html";
import { getHero, Choice, defaults } from "../../global.ts";
import { User } from "firebase/auth";
import { HbMain } from "../../hb-main/hb-main.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

export class HbFeatures extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private hero = new Hero();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;
    private features: HTMLElement;
    private form: HTMLFormElement;
    private save: HTMLButtonElement;
    private message: HTMLParagraphElement;

    private checkinOn: SVGElement;
    private checkinOff: SVGElement;
    private checkinEnable: HTMLButtonElement;
    private checkinDisable: HTMLButtonElement;

    private arOn: SVGElement;
    private arOff: SVGElement;
    private arEnable: HTMLButtonElement;
    private arDisable: HTMLButtonElement;

    private lockerShuffle: HTMLInputElement;
    private lockerShuffleLabel: HTMLSpanElement;

    private safeShuffle: HTMLInputElement;
    private safeShuffleLabel: HTMLSpanElement;

    private checkin = defaults.checkin;
    private ar = defaults.ar;
    private locker: Choice = defaults.locker;
    private safe: Choice = defaults.safe;

    constructor() {
        super();
        render(template(null), this);

        this.features = this.querySelector("#hb-features")!;
        this.form = this.querySelector("#hb-features-form")!;
        this.save = this.querySelector("#hb-features-save")!;
        this.message = this.querySelector("#hb-features-message")!;

        this.checkinOn = this.querySelector("#hb-features-checkin-on")!;
        this.checkinOff = this.querySelector("#hb-features-checkin-off")!;
        this.checkinEnable = this.querySelector("#hb-features-checkin-enable")!;
        this.checkinDisable = this.querySelector(
            "#hb-features-checkin-disable"
        )!;

        this.arOn = this.querySelector("#hb-features-ar-on")!;
        this.arOff = this.querySelector("#hb-features-ar-off")!;
        this.arEnable = this.querySelector("#hb-features-ar-enable")!;
        this.arDisable = this.querySelector("#hb-features-ar-disable")!;

        this.lockerShuffle = this.querySelector("#hb-features-locker-shuffle")!;
        this.lockerShuffleLabel = this.querySelector(
            "#hb-features-locker-label"
        )!;
        this.safeShuffle = this.querySelector("#hb-features-safe-shuffle")!;
        this.safeShuffleLabel = this.querySelector("#hb-features-safe-label")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                // window.location.hash =
                //     "#/onboard/training-" + (this.heartbank.user ? "2" : "1");
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-features",
            override: true
        };

        this.modal = new Modal(this.features, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //this.render(null); // redundant

        // this.lockerShuffle.addEventListener(
        //     "click",
        //     () =>
        //         (this.lockerShuffleLabel.textContent = this.lockerShuffle
        //             .checked
        //             ? "Shuffle"
        //             : "Remember")
        // );
        // this.safeShuffle.addEventListener(
        //     "click",
        //     () =>
        //         (this.safeShuffleLabel.textContent = this.safeShuffle.checked
        //             ? "Shuffle"
        //             : "Remember")
        // );

        this.checkinEnable.addEventListener("click", () => {
            this.checkin = false;
            this.renderCheckin();
        });
        this.checkinDisable.addEventListener("click", () => {
            this.checkin = true;
            this.renderCheckin();
        });

        this.arEnable.addEventListener("click", () => {
            this.ar = true;
            this.renderAR();
        });
        this.arDisable.addEventListener("click", () => {
            this.ar = false;
            this.renderAR();
        });

        this.save.addEventListener("click", async () => {
            //TODO: show spinner
            this.save.disabled = true;
            this.save.textContent = "Saving...";
            this.form.style.opacity = "0.5";

            const locker = this.querySelector(
                "input[name=hb-features-locker]:checked"
            ) as HTMLInputElement;
            if (locker.value === "manual")
                locker.value = this.lockerShuffle.checked
                    ? "shuffle"
                    : "remember";
            this.locker = locker.value as Choice;

            if (this.heartbank.user) {
                const safe = this.querySelector(
                    "input[name=hb-features-safe]:checked"
                ) as HTMLInputElement;
                if (safe.value === "manual")
                    safe.value = this.safeShuffle.checked
                        ? "shuffle"
                        : "remember";
                this.safe = safe.value as Choice;

                await this.hero.updateFeatures({
                    checkin: this.checkin,
                    ar: this.ar,
                    locker: this.locker,
                    safe: this.safe
                });
            } else {
                localStorage.setItem(
                    "features",
                    JSON.stringify({
                        checkin: this.checkin,
                        ar: this.ar,
                        locker: this.locker
                    })
                );
            }

            this.save.disabled = false;
            this.save.textContent = "Save";
            this.form.style.opacity = "";
            this.message.textContent =
                "Your advanced feature settings have been saved succcessfully";
            this.message.style.color = "green";
            //this.hide();

            // re-render: step 1, 2, 4 // maybe 3 ??
            this.main.renderShip(this.heartbank.user);
            this.main.renderSilver(this.heartbank.user);
            this.main.renderX(this.heartbank.user);
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
            this.render(user);
        });
    }

    show() {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private render(user: User | null) {
        if (user) {
            const features = JSON.parse(getHero().features || "{}");
            this.checkin = features.checkin || defaults.checkin;
            this.ar = features.ar || defaults.ar;
            this.locker = features.locker || defaults.locker;
            this.safe = features.safe || defaults.safe;

            this.renderCheckin();
            this.renderAR();
            this.renderLocker();
            this.renderSafe();
        } else {
            const features = JSON.parse(
                localStorage.getItem("features") || "{}"
            );
            this.checkin = features.checkin || defaults.checkin;
            this.ar = features.ar || defaults.ar;
            this.locker = features.locker || "anonymous"; //defaults.locker;

            this.renderCheckin();
            this.renderAR();
            this.renderLocker();
        }
    }

    private renderCheckin() {
        //this.checkinEnable.textContent = this.checkin ? "Encrypted" : "Encrypt";
        this.checkinEnable.classList.toggle("underline", !this.checkin);

        // this.checkinDisable.textContent = this.checkin
        //     ? "Decrypt"
        //     : "Decrypted";
        this.checkinDisable.classList.toggle("underline", this.checkin);

        this.checkinOn.classList.toggle("hidden", this.checkin);
        this.checkinOff.classList.toggle("hidden", !this.checkin);
    }

    private renderAR() {
        this.arEnable.textContent = this.ar ? "Enabled" : "Enable";
        this.arEnable.classList.toggle("underline", this.ar);

        this.arDisable.textContent = this.ar ? "Disable" : "Disabled";
        this.arDisable.classList.toggle("underline", !this.ar);

        this.arOn.classList.toggle("hidden", !this.ar);
        this.arOff.classList.toggle("hidden", this.ar);
    }

    private renderLocker() {
        const value =
            this.locker === "remember" || this.locker === "shuffle"
                ? "manual"
                : this.locker;
        const radios = document.querySelectorAll<HTMLInputElement>(
            "input[name=hb-features-locker]"
        );

        radios.forEach((radio) => (radio.checked = radio.value === value));
        this.lockerShuffle.checked = this.locker === "shuffle";
        // this.lockerShuffleLabel.textContent =
        //     this.locker === "shuffle" ? "Shuffle" : "Remember";
    }

    private renderSafe() {
        const value =
            this.safe === "remember" || this.safe === "shuffle"
                ? "manual"
                : this.safe;
        const radios = document.querySelectorAll<HTMLInputElement>(
            "input[name=hb-features-safe]"
        );

        radios.forEach((radio) => (radio.checked = radio.value === value));
        this.safeShuffle.checked = this.safe === "shuffle";
        // this.safeShuffleLabel.textContent =
        //     this.safe === "shuffle" ? "Shuffle" : "Remember";
    }
}
